/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, Fragment } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import "../css/Ideas.css";
import { db } from "../firebase";
import { mostrarError } from '../utils/Alertas';

interface Idea {
    id: string;
    idea: string;
}

const IdeasCompletadas: React.FC = () => {
    const [comidaCompletadas, setComidaCompletadas] = useState<Idea[]>([]);
    const [actividadesCompletadas, setActividadesCompletadas] = useState<Idea[]>([]);

    const mostrarIdeasCompletadas = async () => {
        try {
            const comidaCompletadasSnapshot = await getDocs(collection(db, 'ComidasCompletadas'));
            const comidaCompletadasList: Idea[] = [];
            comidaCompletadasSnapshot.forEach(doc => {
                comidaCompletadasList.push({ id: doc.id, idea: doc.data().idea });
            });
            setComidaCompletadas(comidaCompletadasList);

            const actividadesCompletadasSnapshot = await getDocs(collection(db, 'ActividadesCompletadas'));
            const actividadesCompletadasList: Idea[] = [];
            actividadesCompletadasSnapshot.forEach(doc => {
                actividadesCompletadasList.push({ id: doc.id, idea: doc.data().idea });
            });
            setActividadesCompletadas(actividadesCompletadasList);
        } catch (error) {
            console.error('Error obteniendo las ideas completadas: ', error);
            mostrarError('Error obteniendo las ideas completadas.');
        }
    };

    useEffect(() => {
        mostrarIdeasCompletadas();
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <Fragment>
            <div className="container-fluid">
                <div className="text-center">
                    <h2 className="pb-2">Ideas Completadas</h2>
                </div>

                <div className="container-fluid content">
                    {comidaCompletadas.length > 0 && <div className="list" id="comidaCompletadasList">
                        <h3>Comidas</h3>
                        <ul id="comidaCompletadasItems">
                            {comidaCompletadas.map((item) => (
                                <li key={item.id} className="idea-item">{item.idea}</li>
                            ))}
                        </ul>
                    </div>}

                    {actividadesCompletadas.length > 0 && <div className="list" id="actividadesCompletadasList">
                        <h3>Actividades</h3>
                        <ul id="actividadesCompletadasItems">
                            {actividadesCompletadas.map((item) => (
                                <li key={item.id} className="idea-item">{item.idea}</li>
                            ))}
                        </ul>
                    </div>}
                </div>
            </div>
        </Fragment>
    );
};

export default IdeasCompletadas;
